import React from 'react'

import {
  faAward as faAwardLight,
  faBriefcase as faBriefcaseLight,
  faCalendar as faCalendarLight,
  faHashtag as faHashtagLight,
  faList as faListLight,
  faUniversity as faUniversityLight,
} from '@fortawesome/pro-light-svg-icons'
import { faAward, faBriefcase, faCalendar, faHashtag, faList, faUniversity } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const CAREERS = 'careers'
export const PROGRAMS = 'programs'
export const COLLEGES = 'search'
export const POSTS = 'posts'
export const OUR_COLLEGES = 'ourColleges'
export const CONTACTS = 'contacts'
export const EVENTS = 'events'

export const COLLEGES_TAB_INDEX = 0
export const POSTS_TAB_INDEX = 2
export const EVENTS_TAB_INDEX = 3
export const PROGRAMS_TAB_INDEX = 4
export const CAREERS_TAB_INDEX = 5

export const DISPLAY_ORDER = [COLLEGES, OUR_COLLEGES, POSTS, EVENTS, CONTACTS, PROGRAMS, CAREERS]

export const TABS = {
  [COLLEGES]: {
    text: 'Colleges',
    value: COLLEGES,
    getUrl: (url) => `${url}/search`,
    icons: {
      active: faUniversity,
      inactive: faUniversityLight,
    },
  },

  [POSTS]: {
    text: 'Posts',
    value: POSTS,
    getUrl: (url) => `${url}/posts`,
    icons: {
      active: faHashtag,
      inactive: faHashtagLight,
    },
  },

  [OUR_COLLEGES]: {
    text: 'Our Colleges',
    value: OUR_COLLEGES,
    getUrl: (url) => `${url}/ours`,
    icons: {
      active: faList,
      inactive: faListLight,
    },
  },
  [EVENTS]: {
    text: 'Events',
    value: EVENTS,
    getUrl: (url) => `${url}/events`,
    icons: {
      active: faCalendar,
      inactive: faCalendarLight,
    },
  },

  [CONTACTS]: {
    text: 'Contacts',
    value: CONTACTS,
    getUrl: (url) => `${url}/contacts`,
    icons: {},
  },
  [PROGRAMS]: {
    text: 'Programs',
    value: PROGRAMS,
    getUrl: (url) => `${url}/programs`,
    icons: {
      active: faAward,
      inactive: faAwardLight,
    },
  },
  [CAREERS]: {
    text: 'Careers',
    value: CAREERS,
    getUrl: (url) => `${url}/search/careers`,
    icons: {
      active: faBriefcase,
      inactive: faBriefcaseLight,
    },
  },
}

export const getIcon = (icons, active) =>
  !icons.active || !icons.inactive ? null : (
    <FontAwesomeIcon
      icon={active ? icons.active : icons.inactive}
      size="sm"
    />
  )
